<template>
  <MenuLayout>
    <div v-if="loading">
      <LoadingSpinner />
    </div>
    <div v-else>
      <!-- Start of user register form -->
      <div class="row justify-content-center">
          <form class="card mt-3 p-3 col-md-6 col-lg-6 col-sm-12">
                  <h4 class="fw-bold mb-4">User Register Form</h4>
                  <div class="row mb-2">
                      <label class="text-start col-md-4">ID<span class="text-danger">*</span></label>
                      <div class="col-md-8 col-12">
                      <input type="text" class="form-control form-control-sm" id="uid" v-model="userData.uid"
                      :maxlength="max_length.uid" :class="{ 'is-invalid': error.idError, }" :disabled="updateMode" />
                      </div>
                  </div>
                  <div class="row mb-2">
                      <label class="text-start col-md-4">Name<span class="text-danger">*</span></label>
                      <div class="col-md-8 col-12">
                      <input type="text" class="form-control form-control-sm" id="name" v-model="userData.name"
                      :maxlength="max_length.name" :class="{ 'is-invalid': error.nameError, }" />
                      </div>
                  </div>
                  <div class="row mb-2">
                      <label class="text-start col-md-4">Email<span class="text-danger">*</span></label>
                      <div class="col-md-8">
                      <input type="email" class="form-control form-control-sm" id="email" v-model="userData.email"
                      :maxlength="max_length.email" :class="{ 'is-invalid': error.emailError }" />
                      </div>
                  </div>
                  <div class="row">
                      <label class="text-start col-md-4">Role</label>
                      <div class="col-md-8 col-12">
                          <select class="form-select form-select-sm col-md-12 selectBorder" v-model="selectedRole" required
                           :class="{ 'is-invalid': error.roleError }">
                              <option selected value="">Select</option>
                              <option v-for="(value, key) in role" :key="key" :value="key">
                              {{value}}
                              </option>
                          </select>
                      </div>
                  </div>
                  <div class="d-flex justify-content-end mt-3">
                      <button class="btn btn-primary" v-on:click.prevent="add_update_data()">
                      <span v-if="updateMode">Update</span>
                      <span v-else>Register</span>
                      </button>
                      <button class="btn btn-secondary me-0" v-on:click.prevent="cancel()">Cancel</button>
                  </div>
          </form>
      </div>
      <!-- End of user register form -->
      <!-- Start of user register table -->
      <div class="tbl-container mt-2">
          <div class="badge default-psw">Default Password - {{ this.defaultPassword }}</div><br><br>
          <div class="col-xxl-10 offset-xxl-1">
            <table id="dataTable" class="table table-responsive">
            <thead>
              <tr>
                <th class="index-width">No</th>
                <th v-for="header in tableHeaders" :key="header">
                  {{ header === "uid" ? "User ID" : header }}
                </th>
                <th class="th-class"></th>
                <th class="th-class"></th>
                <th class="th-class"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in userList" :key="index">
                <td class="text-center">{{ index + 1 }}</td>
                <td v-for="header in tableHeaders" :key="header" class="text-load"
                  v-bind:title="(header === 'email' || header === 'name') ? row[header] : ''"
                  v-bind:data-toggle="(header === 'email' || header === 'name') ? 'tooltip' : null">
                  <span v-if="header === 'name'">
                    <span v-if="row.status !== 1" v-on:click="user_permission(row.uid)" class="cursor-on">{{ row[header.toLowerCase()] }}</span>
                    <span v-else class="text-decoration-none text-black">{{ row[header.toLowerCase()] }}</span>
                  </span>
                  <span v-else>
                      {{
                        header === "status" ? (row.status === 1 ? "Inactive" : "Active") :
                        header === "role" && role[row[header]] ? role[row[header]] :
                        row[header]
                      }}
                  </span>
                </td>
                <td class="text-center">
                  <i class="bi bi-pencil-square fs-6" data-toggle="tooltip" title="Edit"
                    v-on:click="show_data(row.uid)" :class="{ 'disabled-btn': row.status === 1 }"></i>
                </td>
                <td class="text-center">
                  <i v-if="row.status === 1" class="bi bi-recycle fs-6" data-toggle="tooltip" title="Restore"
                    v-on:click="delete_restore(row)"></i>
                  <i v-else class="bi bi-trash3-fill fs-6" data-toggle="tooltip" title="Delete"
                    v-on:click="delete_restore(row)"
                  ></i>
                </td>
                <td class="text-center">
                  <i class="bi bi-person-lock fs-6" data-toggle="tooltip" title="Password Reset"
                    v-on:click="reset_psw(row)" :class="{ 'disabled-btn': row.status === 1 }"></i>
                </td>
              </tr>
            </tbody>
          </table>
          </div>
      </div>
      <!-- End of user register table -->
      </div>
    <loading-modal :loading="loading_model.process_loading" :loading_text="loading_model.loading_text"></loading-modal>
  </MenuLayout>
</template>
<style lang="css" scoped src="@/assets/css/user.css"></style>
<script>
import MenuLayout from "@/components/MenuLayout.vue";
import Configuration from "@/Service/configuration.js";
import DataService from "@/Service/data-service.js";
import ConstantVar from "@/Service/constant-var.js";
import Swal from "sweetalert2";
import { swal_option } from "@/Util/swal-option.js";
import "datatables.net-bs4/css/dataTables.bootstrap4.css";
import "datatables.net-responsive-bs4/css/responsive.bootstrap4.css";
import "datatables.net";
import "datatables.net-bs4";
import "datatables.net-responsive-bs4";
import $ from "jquery";
import { msg_code } from "@/Util/msg_code.js";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import LoadingModal from '@/components/LoadingModal.vue';
import Enum from "@/Service/enum.js";
import { mapState } from "vuex";
var dataService = new DataService();
var config = new Configuration();
var con_var = new ConstantVar();
var enums = new Enum();
export default {
  components: {
    MenuLayout,
    LoadingSpinner,
    'loading-modal': LoadingModal,
  },
  data() {
    return {
      max_length: {},
      loading: null,//データの取得
      loading_model : {},
      userList: [],
      userData: {},
      error: {
        idError: false,
        nameError: false,
        emailError: false,
        roleError: false,
      }, //入力を表示
      updateMode: false, //トレース更新モードへ
      defaultPassword: null, //ユーザーのデフォルトのパスワード
      tableHeaders: [],
      tableColumns:[],
      role:[],
      selectedRole:'',
    };
  },
  computed: {
    ...mapState(["userID"]),
  },
  async mounted() {
    this.role = enums.ROLE;
    this.defaultPassword = con_var.DEFAULT_PASSWORD;
    this.max_length = con_var.USER_MAX_LENGTH;
    this.loading = con_var.LOADING_INTI;
    this.loading_model = con_var.LOADING_MODEL;
    var serverResponse = await dataService.retrieveWithGet(config.SERVICE_NAME_USER);
    this.userList = serverResponse.data;
    this.tableColumns = this.userList.map(user => ({
      uid: user.uid,
      name: user.name,
      email: user.email,
      role: user.role,
      status: user.status,
    }));//ユーザーテーブルの列
    this.fetchData();
    this.loading = false;
    this.initDataTableAfterFetch();
  },
  methods: {
    fetchData() {
      if (this.userList.length > 0) {
        this.headers = Object.keys(this.tableColumns[0]);
      }
      this.tableHeaders = this.headers;
    },
    initDataTableAfterFetch() {
      this.$nextTick(() => {
        $(this.$el)
          .find("#dataTable")
          .DataTable({
            scrollX: true,
            scrollY: '450px',
            searching: true,
            "columnDefs": [{
              "targets": 'th-class',
              "orderable": false
            }],
            language: {
              "info": "Page _PAGE_ of _PAGES_",
              paginate: {
                next: '&#x3e;', // or '>'
                previous: '&#x3c;' // or '<'
              },
              sLengthMenu: "_MENU_ ",
            },
          });
      });
    },
    validateForm() {//入力を検証する
      this.error.idError = false;
      this.error.nameError = false;
      this.error.emailError = false;
      this.error.roleError = false;
      let errorText = "";
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!this.userData.uid) {
        this.error.idError = true;
      } else if (!Number.isInteger(Number(this.userData.uid))) {
        errorText += msg_code("wf005") + "<br>";
        this.error.idError = true;
      }
      if (!this.userData.name) {
        this.error.nameError = true;
      }
      if (!this.userData.email) {
        this.error.emailError = true;
      } else if (!emailPattern.test(this.userData.email)) {
        errorText += msg_code("wf006") + "<br>";
        this.error.emailError = true;
      }
      if (!this.selectedRole) {
        this.error.roleError = true;
      }
      if (errorText) {
        Swal.fire({ ...swal_option("warn", ""), html: errorText });
      }
      return !(this.error.idError || this.error.nameError || this.error.emailError || this.error.roleError); // 検証パス
    },
    user_permission(uid) {
      this.$router.push({ name: 'userPermission', params: { uid: uid } });
    },
    async show_data(uid) {
      this.loading_model = {process_loading: true, loading_text: 'Processing'};
      this.error.idError = false;
      this.error.emailError = false;
      this.error.roleError = false;
      var serverResponse = await dataService.retrieveWithGet(config.SERVICE_NAME_USER + "/" + uid);
      if (serverResponse.success == true) {
        this.userData = serverResponse.data;
        this.selectedRole = this.userData.role;
        this.updateMode = true;
      }
      else if (serverResponse.success == false && serverResponse.error == false) {
        Swal.fire(swal_option("warn", serverResponse.message));
      }
      else {
        Swal.fire(swal_option("error", msg_code("ef001")));
      }
      this.loading_model = con_var.LOADING_MODEL;
    },
    async add_update_data() {
      if (!this.validateForm()) {
        return;
      }
      this.loading_model = {process_loading: true, loading_text: 'Processing'};
      var serverResponse;
      this.userData.role = this.selectedRole;
      this.userData.updated_by = this.userID;
      if (this.userData.id == null) { // 登録モード
        this.userData.created_by = this.userID;
        serverResponse = await dataService.callWithPost(config.SERVICE_NAME_USER, this.userData);
      } else {  // 更新モード
        serverResponse = await dataService.updateWithPut(config.SERVICE_NAME_USER + "/" + this.userData.uid, this.userData);
      }
      if (serverResponse.success == true) {
        Swal.fire(swal_option("success", serverResponse.message));
        this.userList = serverResponse.data; // 一覧表にデータを更新する
        this.userData = {
          uid: null,
          email: null
        };
        this.selectedRole = '';
        this.updateMode = false;
        var table = $("#dataTable").DataTable();
        table.destroy();
        this.fetchData();
        this.initDataTableAfterFetch();
      }
      else if (serverResponse.success == false && serverResponse.error == false) {
        Swal.fire(swal_option("warn", serverResponse.message));
      }
      else {
        Swal.fire(swal_option("error", msg_code("ef001")));
      }
      this.loading_model = con_var.LOADING_MODEL;
    },
    async reset_psw(data) {
        Swal.fire(swal_option("confirm", msg_code("cf001") + data.uid + "?")).then(
          async (result) => {
            if (result.isConfirmed) {
              this.loading_model = {process_loading: true, loading_text: 'Processing'};
              delete data["created_at"];
              delete data["updated_at"];
              data.password = this.defaultPassword;
              var serverResponse = await dataService.updateWithPut(config.SERVICE_NAME_USER + "/" + data.uid, data); //リセットパスワードを更新する
              if (serverResponse.success == true) {
                Swal.fire(swal_option("success", serverResponse.message + ` of User ID ${data.uid}.`)
                );
                this.userList = serverResponse.data; // 一覧表にデータを更新する
                var table = $("#dataTable").DataTable();
                table.destroy();
                this.fetchData();
                this.initDataTableAfterFetch();
              }
              else if (serverResponse.success == false && serverResponse.error == false) {
                Swal.fire(swal_option("warn", serverResponse.message));
              }
              else {
                Swal.fire(swal_option("error", msg_code("ef001")));
              }
            }
            this.loading_model = con_var.LOADING_MODEL;
          }
        );
      },
    async delete_restore(data) {
      var serverResponse = null;
        var delete_data = { "uid": data.uid, "update_key": data.update_key };
        const messageCode = data.del_flg === 0 ? "cf002" : "cf013";//削除または復元
        Swal.fire(swal_option("confirm", msg_code(messageCode) + data.uid + "?")).then(
          async (result) => {
            if (result.isConfirmed) {
              this.loading_model = {process_loading: true, loading_text: 'Processing'};
              serverResponse = await dataService.callWithPost(config.SERVICE_NAME_USER_DESTROY, delete_data);
              if (serverResponse.success == true) {
                Swal.fire(swal_option("success", serverResponse.message));
                this.userList = serverResponse.data;
                this.userData = {
                  uid: null,
                  email: null,
                };
                this.updateMode = false;
                var table = $("#dataTable").DataTable();
                table.destroy();
                this.initDataTableAfterFetch();
              }
              else if (serverResponse.success == false && serverResponse.error == false) {
                Swal.fire(swal_option("warn", serverResponse.message));
              }
              else {
                Swal.fire(swal_option("error", msg_code("ef001")));
              }
              this.loading_model = con_var.LOADING_MODEL;
            }
          }
        );
      },
    cancel() {
      this.userData = {
        uid: null,
      };
      this.selectedRole = '';
      this.updateMode = false;
      this.error.idError = false;
      this.error.nameError = false;
      this.error.emailError = false;
      this.error.roleError = false;
    },
  },
};
</script>
